export function getPageTitle(
  menuItem: IMenuItem,
  position: number,
  isShownTags: boolean,
  extras: any
) {
  const {
    menu_item_preference_ids,
    menu_item_name_public,
    menu_item_extras_groups_ids,
  } = menuItem;
  const preferenceGreater = menu_item_preference_ids?.length > 0;
  /**If on allergys page show allergies header */
  if (position === 0 && isShownTags) {
    return "Menu.Allergens";
    /**If on first page show menu item name */
  } else if (position === 0) {
    return menu_item_name_public;
    /**If on preferences page show the pref title */
  } else if (preferenceGreater && position === 1) {
    return "Menu.Preferences";
    /**if the positin is at the last then show the confirmation title */
  } else if (
    position ===
    (preferenceGreater ? 1 : 0 + menu_item_extras_groups_ids.length + 1)
  ) {
    return "Menu.Confirmation";
  } else {
    const extraId =
      menu_item_extras_groups_ids[position - (preferenceGreater ? 2 : 1)];
    const extraData = extras[extraId];
    return extraData?.menu_item_extra_group_name_public;
  }
}
